import { combineReducers } from 'redux'
import { LOAD_PAIRS, LOAD_PERFORMACE, LOAD_PERFORMACE_DATES, SET_FUND, SET_BMK, SET_DATE, SET_PERIOD, SET_CATEGORY, SET_SORT, SORT_DATA, LOAD_PERFORMACE_DATES_URL } from '../actions'

const initialState = {
  pairs: [],
  fund: '',
  bmk: '',
  date: '',
  data: [],
  categories: [],
  category: 'sector',
  categoryData: [],
  period: 'SI',
  periodData: [],
  sortDirection: '',
  sortColumn: ''
}

const performance = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PAIRS:
      return Object.assign({}, state, {
        pairs: action.payload
      })
    case LOAD_PERFORMACE:
      const category = state.category
      const period = state.period
      let categories = [...new Set(action.payload.map(entity => entity.category_type))]
      let catdata = getCategoryData(action.payload, category)
      console.log('categories', categories)
      console.log('category', category)
      return Object.assign({}, state, {
        data: action.payload,
        categories: categories,
        category: category,
        categoryData: catdata,
        period: period,
        sortColumn: 'Total',
        sortDirection: 'DESC',
        periodData: getPeriodData(catdata, period)
      })
    case LOAD_PERFORMACE_DATES:
      let dates = action.payload
      let latest = new Date(dates[dates.length - 1].curr_date).toISOString().split('T')[0]
      return Object.assign({}, state, {
        dates: dates,
        date: latest
      })
    case LOAD_PERFORMACE_DATES_URL:
      return Object.assign({}, state, {
        dates: action.payload
      })
    case SET_FUND:
      let benchmarks = state.pairs.filter(function (value) {
        return value.fund === action.payload
      })
      return Object.assign({}, state, {
        fund: action.payload,
        bmk: benchmarks[0].bmk,
        period: 'SI',
        category: 'sector'
      })
    case SET_BMK:
      return Object.assign({}, state, {
        bmk: action.payload,
        period: 'SI',
        category: 'sector'
      })
    case SET_DATE:
      return Object.assign({}, state, {
        date: action.payload
      })
    case SET_CATEGORY:
      let newCatData = getCategoryData(state.data, action.payload)
      let defSort = getDefaultSort(action.payload)
      let sortColumn = defSort[0]
      let sortDirection = defSort[1]
      return Object.assign({}, state, {
        category: action.payload,
        categoryData: newCatData,
        periodData: getPeriodData(newCatData, state.period),
        sortColumn: sortColumn,
        sortDirection: sortDirection
      })
    case SET_PERIOD:
      return Object.assign({}, state, {
        period: action.payload,
        periodData: getPeriodData(state.categoryData, action.payload)
      })
    case SET_SORT:
      let column = action.column
      let direction = state.sortDirection
      if (column === '') {
        direction = ''
      } else if (column === state.sortColumn) {
        direction = state.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        direction = 'ASC'
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction
      })
    case SORT_DATA:
      let sortedData = state.periodData
      if (state.sortColumn === 'Category') {
        sortedData = state.periodData.sort((a, b) => a[state.sortColumn.toLowerCase()].localeCompare(b[state.sortColumn.toLowerCase()]))
      } else {
        sortedData = state.periodData.sort((a, b) => a[state.sortColumn.toLowerCase()] - b[state.sortColumn.toLowerCase()])
      }

      console.log('sortedData', sortedData)

      let total = null
      let na = null
      let tenth = null
      sortedData = sortedData.filter(function (value) {
        if (value.category === 'Total') {
          total = value
          return false
        } else if (value.category === 'N/A') {
          na = value
          return false
        } else if (value.category.startsWith('10th Decile')) {
          tenth = value
          return false
        } else {
          return true
        }
      })
      if (tenth) {
        sortedData.push(tenth)
      }
      if (state.sortDirection === 'DESC') {
        sortedData.reverse()
      }
      if (na) {
        sortedData.push(na)
      }
      if (total) {
        sortedData.push(total)
      }
      return Object.assign({}, state, {
        periodData: sortedData
      })
    default:
      return state
  }
}

function getDefaultSort(category) {
  switch (category) {
    case 'sector':
    case 'country':
      return ['Total', 'DESC']
    case 'wtsize':
      return ['Category', 'ASC']
    default:
      return ['Category', 'ASC']
  }
}

function getCategoryData(data, category) {
  return data.filter(function (value) {
    return value.category_type === category
  })
}

// function getEarliestPeriod(data) {
//   let period = 'SI'
//   let periods = ['SI', 'MTD', 'QTD', 'YTD', '1Y', '3Y', '5Y', '10Y']
//   for (let index = 0; index < periods.length; index++) {
//     let result = checkForPeriodData(data, periods[index])
//     if (result) {
//       period = periods[index]
//       break
//     }
//   }
//   return period
// }

// function checkForPeriodData(data, period) {
//   let periodData3 = data.filter(function (value) {
//     return value.period === period
//   })
//   return periodData3[0] ? true : false
// }

function getPeriodData(data, period) {
  return data.filter(function (value) {
    return value.period === period
  })
}

const rootReducer = combineReducers({
  performance
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js